//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import banner from '@/assets/jifenhuangou/banner.png'
export default {
  name: 'ruleIndex',
  components: {
  },
  data () {
    return {
      banner: banner
    }
  },
  computed: {
  },
  watch: {
  },
  methods: {
  },
  created () {
  }
}
